import { render, staticRenderFns } from "./facturastoexcel.vue?vue&type=template&id=2786c4e3"
import script from "./facturastoexcel.vue?vue&type=script&lang=js"
export * from "./facturastoexcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports